import React, { useMemo } from 'react';
import { TextOverflow, Text, ErrorHandler } from '@common/components';
import { useQuery } from '@common/hooks';
import { ENUM_QUERY } from '@common/graphql';

type AssignmentCancelReasonProps = {
  reasonName?: string;
  details?: string;
};

export function AssignmentCancelReason({
  reasonName,
  details,
}: AssignmentCancelReasonProps) {
  const { data, loading, error } = useQuery(ENUM_QUERY, {
    variables: {
      key: 'AssignmentCancelledReason',
    },
  });

  const cancelledReasonDescription = useMemo(
    () => data?.enum?.find((v) => v.name === reasonName)?.description || '',
    [reasonName, data?.enum]
  );

  if (error) {
    return <ErrorHandler error={error} log="AssignmentCancelReason" />;
  }

  if (loading) {
    return null;
  }

  return (
    <TextOverflow tooltip={details}>
      <Text color="coral">{cancelledReasonDescription}</Text>
    </TextOverflow>
  );
}
